import React from 'react'
import { Container, Typography, makeStyles } from '@material-ui/core'
import { noBorderContainerStyle } from '../styles/styles'

const useStyles = makeStyles((theme) => ({
  section: {
    marginTop: '20px',
    paddingLeft: '15px'
  }
}))
const HeaderContainer = (props) => {
  const classes = noBorderContainerStyle()
  const customClasses = useStyles()

  return props.isEvaluator ? (
    <Container>
      <div className={classes.root}>
        <Typography className={customClasses.section} variant='h4'>
          Professional Reference Request
        </Typography>
        <Typography className={customClasses.section} variant='body1'>
          {props.profile?.firstName} has applied for employment with
          AMN Healthcare and has asked you to provide a professional
          reference. References are an essential component to the AMN Candidate
          Qualification Process. Your feedback is confidential. The individual
          who requested this reference will not have access to your responses.
        </Typography>
      </div>
    </Container>
  ) : (
    <Container>
      <div className={classes.root}>
        <Typography className={customClasses.section} variant='h4'>
          Strengthen Your Work History
        </Typography>
        <Typography className={customClasses.section} variant='body1'>
          Professional references help highlight the quality of care you
          have provided in the past. They are a necessary step prior to
          submitting your profile to job opportunities. Evaluator feedback is confidential and responses will not be shared with you.
        </Typography>
      </div>
    </Container>
  )
}

export default HeaderContainer
